export function isAbortError(error: unknown): boolean {
  return typeof error === 'object'
    && error !== null
    && 'name' in error
    && (error as { name?: unknown }).name === 'AbortError';
}

// Substrings identifying a connectivity drop mid-transfer. Browsers reject a failed fetch with a
// TypeError whose message differs per engine (Chrome "Failed to fetch", Firefox "NetworkError...",
// Safari "Load failed", undici "fetch failed"), so match on the message rather than the type.
const NETWORK_ERROR_PATTERNS = [
  'failed to fetch',
  'networkerror',
  'network error',
  'load failed',
  'fetch failed',
  'network connection was lost',
  'connection appears to be offline',
];

// A lost/flaky connection during an upload or download - the user's own environment, not an app or
// backend fault. Not actionable server-side and only adds noise to exception telemetry, so callers
// log it to the console instead of reporting it. Deliberately narrow: a genuine backend failure
// surfaces as an Error carrying an HTTP status message (e.g. "Service Unavailable") and a decryption
// failure (which can mean a corrupt stored object) are NOT matched, so both stay visible in telemetry.
export function isBenignTransferError(error: unknown): boolean {
  if (!(error instanceof Error)) {
    return false;
  }

  const message = error.message.toLowerCase();
  return NETWORK_ERROR_PATTERNS.some((pattern) => message.includes(pattern));
}
